import styled from 'styled-components'

export const PayPalMessageContainer = styled.div`
  display: block;
  width: 100%;
`
